import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { forgotCustomer } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";

import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";

class Forgot extends Component {
  state = {
    errors: [],
    email: ""
  };

  renderErrorMessage() {
    if (this.props.customer.forgot !== null) {
      if (this.props.customer.forgot === true) {
        return (
          <div
            className="alert alert-success"
            role="alert"
            style={{ marginTop: 20 }}
          >
            <h4 className="alert-heading">Şifrenizi Sıfırlama Maili Gönderildi!</h4>
            <p>
              Şifrenizi sıfırlayabilmeniz için E-Mail adresinize bir Mail
              gönderdik. Oradaki adımları takip ederek şifrenizi
              sıfırlayabilirsiniz.
            </p>
          </div>
        );
      }
      if (this.props.customer.forgot === false) {
        return (
          <div
            className="alert alert-danger"
            role="alert"
            style={{ marginTop: 20 }}
          >
            <h4 className="alert-heading">Hata Meydana Geldi!</h4>
            <p>
              Beklenmedik bir hata meydana geldi ve şifrenizi sıfırlama maili
              gönderilemedi! Lütfen bizimle iletişime geçmeyi deneyin.
            </p>
          </div>
        );
      }
    }
    if (
      this.props.customer.forgotError &&
      this.props.customer.forgotError.length > 0
    ) {
      return (
        <div className="alert alert-danger" role="alert" style={{ marginTop: 20 }}>
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.forgotError.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div className="alert alert-danger" role="alert" style={{ marginTop: 20 }}>
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.forgotCustomer({ ...this.state });
    }
  };

  render() {
    if (this.props.customer.customer) {
      return (
        <Redirect
          to={{
            pathname: "/hesabim"
            // state: { referrer: currentLocation }
          }}
        />
      );
    }
    return (
      <React.Fragment>
        <PageTitle title={"Şifremi Unuttum"} />
        <div className="row">
          <div className={"col-md-6 offset-md-3"}>
            <div className={styles.loginBox}>
              <div className={"overlay-content"} />
              <div className={"tab-content"}>
                <h3>Şifremi Unuttum</h3>
                {!this.props.customer.forgot && (
                  <form onSubmit={this.onSubmit}>
                    <div className={"clearfix large_form"}>
                      <input
                        type="email"
                        name="email"
                        placeholder="E-mail Adresiniz"
                        defaultValue={this.state.email}
                        onChange={e => {
                          this.handleChange(e);
                        }}
                        required
                      />
                    </div>
                    <div className={"clearfix large_form text-left"}>
                      <p>
                        E-Mail adresinize şifrenizi sıfırlamanız için bir
                        bağlantı gönderilecektir.
                      </p>
                    </div>
                    <div className={"clearfix large_form text-left"}>
                      <button
                        disabled={this.props.customer.forgotFetching}
                        style={
                          this.props.customer.forgotFetching
                            ? { opacity: 0.5 }
                            : {}
                        }
                        type="submit"
                      >
                        {this.props.customer.forgotFetching
                          ? "BEKLEYİNİZ..."
                          : "ŞİFREMİ SIFIRLA"}
                      </button>
                    </div>
                  </form>
                )}
                {this.renderErrorMessage()}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { forgotCustomer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Forgot);



// WEBPACK FOOTER //
// ./src/routers/Forgot/index.js